import { gql } from '@apollo/client';

export const ADMIN_LOGIN_MUTATION = gql`
  mutation adminLogin($data: String!) {
    adminLogin(data: $data) {
      status
      message
      token
      user {
        id
        email
        phone
        firstName
        lastName
        imageUrl
        role {
          name
          permissions {
            id
            name
          }
        }
      }
    }
  }
`;

export const ADMIN_APPROVE_DOCUMENT = gql`
  mutation approveDocumentCa($id: ID!) {
    approveDocumentCa(id: $id) {
      status
      message
    }
  }
`;

export const ADMIN_REJECT_DOCUMENT = gql`
  mutation rejectDocumentCa($id: ID!, $message: String!) {
    rejectDocumentCa(id: $id, message: $message) {
      status
      message
    }
  }
`;

export const ADMIN_ACTIVATE_CUSTOMER = gql`
  mutation activateUser($id: ID!, $comment: String!) {
    activateUser(id: $id, comment: $comment) {
      message
      status
    }
  }
`;

export const ADMIN_DECLINE_CUSTOMER = gql`
  mutation DeclineUser($id: ID!, $comment: String!) {
    declineUser(id: $id, comment: $comment) {
      status
      message
    }
  }
`;

export const ADMIN_DEACTIVATE_CUSTOMER = gql`
  mutation DeactivateUser($id: ID!, $comment: String!) {
    deactivateUser(id: $id, comment: $comment) {
      message
      status
    }
  }
`;

export const ADMIN_APPROVE_CUSTOMER = gql`
  mutation ApproveUser($id: ID!) {
    approveUser(id: $id) {
      status
      message
    }
  }
`;

export const ADMIN_REFUND_LOAN = gql`
  mutation ProcessRefund($loanId: ID!) {
    processRefund(loanId: $loanId) {
      message
      status
    }
  }
`;
export const ADMIN_COMPLETE_LOAN_REFUND = gql`
  mutation completeRefund($loanId: ID!) {
    completeRefund(loanId: $loanId) {
      message
      status
    }
  }
`;

export const ADMIN_REQUERY_PAYOUT_TRANSACTION = gql`
  mutation RequeryPayoutTransaction($id: ID!) {
    requeryPayoutTransaction(id: $id) {
      message
      status
    }
  }
`;

export const CHECK_USER_ELIGIBILITY = gql`
  mutation CheckEligibility($userId: String!, $amount: Int, $provider: String) {
    checkEligibilityByUserId(
      userId: $userId
      amount: $amount
      provider: $provider
    ) {
      status
      title
      message
      traceId
      offers {
        productId
        deficit
        requestedAmount
        upfrontPayment
        offerAmount
        interestRate
        recommendedRepaymentDates
        installmentAmount
        nextDueDate
        totalRepaymentAmount
        loanAmount
        interestPaid
        repaymentSchedule {
          amountDue
          dueDate
          installmentIndex
          moneyPayMonth
        }
        tenor
        installment
        processingFee
      }
    }
  }
`;

export const ADMIN_MODIFY_CUSTOMER = gql`
  mutation disableEnableUser($id: ID!) {
    disableEnableUser(id: $id) {
      status
      user {
        status
      }
    }
  }
`;

export const ADMIN_ENABLE_CUSTOMER_ELIGIBILITY = gql`
  mutation enableUserEligibility($id: ID!) {
    enableUserEligibility(id: $id) {
      status
      message
    }
  }
`;

export const ADMIN_DISABLE_CUSTOMER_ELIGIBILITY = gql`
  mutation disableUserEligibility($id: ID!) {
    disableUserEligibility(id: $id) {
      status
      message
    }
  }
`;

export const ADMIN_UPDATE_SETTLEMENT = gql`
  mutation updateSettlementStatus($id: ID, $status: SettlementStatus) {
    updateSettlementStatus(id: $id, status: $status) {
      id
      status
      merchantId
      batchNumber
      totalAmount
      totalSettled
      totalFees
      reason
      settlementReference
      date
      createdAt
    }
  }
`;

export const DELETE_MOBILE_CUSTOMER = gql`
  mutation removeUser($id: ID!, $reason: String!) {
    removeUser(id: $id, reason: $reason) {
      status
      message
    }
  }
`;

export const CANCEL_LOAN = gql`
  mutation cancelLoan($loanId: ID!) {
    cancelLoan(loanId: $loanId) {
      status
      message
    }
  }
`;

export const PROCESS_SINGLE_SCHEDULE = gql`
  mutation processSingleLoanSchedule($loanScheduleId: ID!) {
    processSingleLoanSchedule(loanScheduleId: $loanScheduleId) {
      status
      message
    }
  }
`;

export const RESET_PASSWORD = gql`
  mutation adminForgotPassword($email: String!) {
    adminForgotPassword(email: $email, isCanada: true) {
      message
      status
    }
  }
`;

export const ADMIN_CHANGE_PASSWORD = gql`
  mutation adminChangePassword($newPassword: String!, $oldPassword: String!) {
    adminChangePassword(newPassword: $newPassword, oldPassword: $oldPassword) {
      message
      status
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation adminResetPassword($data: String!) {
    adminResetPassword(data: $data) {
      message
      status
    }
  }
`;

export const ADMIN_UPLOAD_DOCUMENT = gql`
  mutation adminUploadUserDocument(
    $name: String!
    $userId: String!
    $file: Upload
    $resourceType: ResourceType
    $provider: String
  ) {
    adminUploadUserDocument(
      name: $name
      userId: $userId
      file: $file
      resourceType: $resourceType
      provider: $provider
    ) {
      id
      status
      imageUrl
      message
    }
  }
`; // adminMerchantUpdateDocument

export const MANUAL_REPAYMENT_UPDATE = gql`
  mutation manualRepaymentUpdate($id: ID!, $file: Upload) {
    manualRepaymentUpdate(id: $id, file: $file) {
      status
      message
    }
  }
`;

export const ADMIN_MERCHANT_UPLOAD_DOCUMENT = gql`
  mutation adminMerchantUpdateDocument(
    $name: String!
    $merchantId: String!
    $file: Upload!
  ) {
    adminMerchantUpdateDocument(
      name: $name
      merchantId: $merchantId
      file: $file
    ) {
      status
      message
      data {
        docKey
        uri
        fileName
        id
      }
    }
  }
`;

export const ADMIN_PROFILE_DETAILS = gql`
  mutation AdminUserUpdate($input: AdminUserUpdateInput!) {
    adminUserUpdate(input: $input) {
      status
      message
    }
  }
`;

export const RETRY_LOAN = gql`
  mutation retryRenmoneyLoan($loanId: ID!, $userId: String) {
    retryRenmoneyLoan(loanId: $loanId, userId: $userId) {
      status
      message
    }
  }
`;

export const REPAYMENT_CONFIG_UPDATE = gql`
  mutation createUpdateRepaymentConfig($input: RepaymentConfigInput!) {
    createUpdateRepaymentConfig(input: $input) {
      status
      message
    }
  }
`;

export const VERIFY_CUSTOMER_BVN = gql`
  mutation verifyCustomerBVNAdmin($userId: ID!, $reason: String!) {
    verifyCustomerBVNAdmin(userId: $userId, reason: $reason) {
      message
      status
    }
  }
`;

export const UNLINK_CUSTOMER_ACCOUNT = gql`
  mutation unlinkCustomerConnectedBankAccountAdmin(
    $userId: ID!
    $reason: String!
  ) {
    unlinkCustomerConnectedBankAccountAdmin(userId: $userId, reason: $reason) {
      message
      status
    }
  }
`;

export const APPROVE_LOAN_PENDING_AUTHORIZATION = gql`
  mutation ApproveLoanPendingAuthorization($id: ID!, $approve: Boolean) {
    approveLoanPendingAuthorization(id: $id, approve: $approve) {
      message
      status
    }
  }
`;

export const APPROVE_LOAN = gql`
  mutation approveCaLoan($id: ID!, $shouldApprove: Boolean) {
    approveCaLoan(id: $id, shouldApprove: $shouldApprove) {
      message
      status
    }
  }
`;

export const APPROVE_GUARANTEE = gql`
  mutation approveRentGuarantee($id: ID!, $shouldApprove: Boolean) {
    approveRentGuarantee(id: $id, shouldApprove: $shouldApprove) {
      message
      status
    }
  }
`;

export const MANUAL_LOAN_CREATE = gql`
  mutation CreateManualLoan($input: ManualCreateLoan) {
    createManualLoan(input: $input) {
      status
      message
      data {
        upfrontPaid
        interestRate
        installmentAmount
        nextDueDate
        totalRepaymentAmount
        loanAmount
        interestPaid
        tenor
        installment
        processingFee
        insurancePremium
        repaymentSchedule {
          dueDate
          amountDue
          installmentIndex
        }
      }
    }
  }
`;

export const PREVIEW_MANUAL_LOAN_CREATE = gql`
  mutation previewManualLoanCreate($input: ManualCreateLoan) {
    previewManualLoanCreate(input: $input) {
      status
      message
      data {
        upfrontPaid
        interestRate
        installmentAmount
        nextDueDate
        totalRepaymentAmount
        loanAmount
        interestPaid
        tenor
        installment
        processingFee
        insurancePremium
        repaymentSchedule {
          dueDate
          amountDue
          installmentIndex
        }
      }
    }
  }
`;

export const DOCUMENT_UPLOAD_AWS = gql`
  mutation addMerchantDocumentAWSWIthFile(
    $name: String!
    $file: Upload!
    $isOnboarding: Boolean
  ) {
    addMerchantDocumentAWSWIthFile(
      name: $name
      file: $file
      isOnboarding: $isOnboarding
    ) {
      status
      message
      data {
        docKey
        uri
        fileName
        id
      }
    }
  }
`;

export const MULTIPLE_FILE_UPLOAD_WITH_TYPE = gql`
  mutation ($pdfFiles: [Files]!) {
    multipleUploadWithType(files: $pdfFiles) {
      url
      filename
    }
  }
`;

export const MULTIPLE_FILE_UPLOAD = gql`
  mutation ($files: [Upload]!) {
    multipleUpload(file: $files) {
      url
      filename
    }
  }
`;

export const UPDATE_MERCHANT_SDK_START_SCREEN = gql`
  mutation updateMerchantSDKStartScreen(
    $merchantId: String!
    $screenType: String!
  ) {
    updateMerchantSDKStartScreen(
      merchantId: $merchantId
      screenType: $screenType
    ) {
      message
      status
    }
  }
`;

export const ACTIVATE_PAYMENT_LINK = gql`
  mutation activateMerchantPaymentLink($name: String!) {
    activateMerchantPaymentLink(name: $name) {
      id
      name
      title
      description
      configurations
      merchantId
      createdAt
      status
      reason
    }
  }
`;

export const DEACTIVATE_PAYMENT_LINK = gql`
  mutation deactivateMerchantPaymentLink($name: String!, $reason: String!) {
    deactivateMerchantPaymentLink(name: $name, reason: $reason) {
      id
      name
      title
      description
      configurations
      merchantId
      createdAt
      status
      reason
    }
  }
`;

export const UPDATE_USER_PROFILE = gql`
  mutation AdminUpdateUserProfileCa(
    $userId: ID!
    $input: AdminUserCaProfileInput
    $institution: institutionInput
  ) {
    adminUpdateUserProfileCa(
      userId: $userId
      input: $input
      institution: $institution
    ) {
      status
      message
    }
  }
`;

export const DELETE_PAYMENT_LINK = gql`
  mutation deleteMerchantPaymentLink($name: String!) {
    deleteMerchantPaymentLink(name: $name) {
      status
      message
    }
  }
`;

export const APPROVE_PRE_APPROVAL_RENT_GUARANTEE = gql`
  mutation ApprovePreApprovalRentGuarantee($id: ID!, $shouldApprove: Boolean) {
    approvePreApprovalRentGuarantee(id: $id, shouldApprove: $shouldApprove) {
      data {
        amount
        currency
        createdAt
        approvedBy
      }
      message
      status
    }
  }
`;

export const MANUAL_PRE_APPROVAL_GUARANTEE_UPDATE = gql`
  mutation ManualPreApprovalGuaranteeUpdate($id: ID!, $file: Upload) {
    manualPreApprovalGuaranteeUpdate(id: $id, file: $file) {
      message
      status
    }
  }
`;

export const UPDATE_RENT_PAYMENT_SETTLEMENT_STATUS = gql`
  mutation UpdateRentPaymentSettlementStatus(
    $rentPaymentId: String!
    $action: String!
    $reason: String
  ) {
    updateRentPaymentSettlementStatus(
      rentPaymentId: $rentPaymentId
      action: $action
      reason: $reason
    ) {
      status
      message
      data {
        id
        rentAmount
        settlementStatus
        user {
          firstName
          lastName
          email
          phone
        }
        property {
          propertyAddress
          leaseAgreementDoc
          landlord_e_transfer_email
          landlord {
            firstName
            companyName
            lastName
            landlordType
            email
            phone
          }
        }
      }
    }
  }
`;

export const INVITE_NEW_STAFF = gql`
  mutation InviteNewStaff($input: NewStaffInput!) {
    inviteNewStaff(input: $input) {
      message
      status
    }
  }
`;

export const EDIT_STAFF = gql`
  mutation EditStaff($adminId: String!, $input: UpdateStaffInput!) {
    editStaff(adminId: $adminId, input: $input) {
      message
      status
    }
  }
`;

export const ADMIN_EDIT_ROLES = gql`
  mutation UpdateRole($input: RoleUpdateInput, $updateRoleRoleId2: ID!) {
    updateRole(input: $input, roleId: $updateRoleRoleId2) {
      message
      status
    }
  }
`;

export const ACTIVATE_AND_DEACTIVATE_STAFF = gql`
  mutation ModifyAdminStatus($adminId: String!, $status: String!) {
    modifyAdminStatus(adminId: $adminId, status: $status) {
      message
      status
    }
  }
`;

export const UPDATE_AGENT_STATUS = gql`
  mutation UpdateAgentStatus($agentId: String!, $isActive: Boolean!) {
    updateAgentStatus(agentId: $agentId, isActive: $isActive) {
      status
      message
    }
  }
`;

export const ADMIN_CREATE_ROLES = gql`
  mutation CreateRole(
    $name: String!
    $displayName: String!
    $permissionIds: [String]
  ) {
    createRole(
      name: $name
      display_name: $displayName
      permissionIds: $permissionIds
    ) {
      message
      status
    }
  }
`;

export const ADMIN_UPDATE_ROLES = gql`
  mutation UpdateRole($input: RoleUpdateInput, $roleId: ID!) {
    updateRole(input: $input, roleId: $roleId) {
      status
      message
    }
  }
`;

export const MODIFY_ROLE_PERMISSIONS = gql`
  mutation ModifyRolePermissions(
    $roleId: ID!
    $permissionIds: [ID]!
    $deletedPermissionIds: [ID]!
  ) {
    modifyRolePermissions(
      roleId: $roleId
      permissionIds: $permissionIds
      deletedPermissionIds: $deletedPermissionIds
    ) {
      message
      status
    }
  }
`;

export const MODIFY_STATUS_OF_BULK_ROLES = gql`
  mutation ModifyStatusOfBulkRoles($roleIds: [String]!, $action: String!) {
    modifyStatusOfBulkRoles(roleIds: $roleIds, action: $action) {
      status
      message
    }
  }
`;

export const REMOVE_MEMBER_FROM_ROLE = gql`
  mutation RemoveMemberFromRole($roleId: String!, $adminId: String!) {
    removeMemberFromRole(roleId: $roleId, adminId: $adminId) {
      status
      message
    }
  }
`;

export const ADD_MEMBERS_TO_ROLE = gql`
  mutation AddMembersToRole($roleId: String!, $userIds: [String]!) {
    addMembersToRole(roleId: $roleId, userIds: $userIds) {
      status
      message
    }
  }
`;

export const MANUAL_RENT_PAYMENT_UPDATE = gql`
  mutation ManualRentPaymentUpdate($id: ID!, $file: Upload) {
    manualRentPaymentUpdate(id: $id, file: $file) {
      message
      status
    }
  }
`;

export const ADMIN_UPDATE_APARTMENT = gql`
  mutation AdminUpdateApartmentSearchStatus(
    $adminUpdateApartmentSearchStatusId: String!
    $status: String!
    $reason: String
  ) {
    adminUpdateApartmentSearchStatus(
      id: $adminUpdateApartmentSearchStatusId
      status: $status
      reason: $reason
    ) {
      status
      message
      data {
        id
        province
        city
        paymentAmount
        apartmentType
        monthlyBudget
        monthlyIncome
        additionalInformation
        status
      }
    }
  }
`;

export const ADMIN_GENERATE_REALTOR_CODE = gql`
  mutation CreatePropertyAgent(
    $firstName: String!
    $email: String!
    $country: String!
    $lastName: String!
  ) {
    createPropertyAgent(
      firstName: $firstName
      email: $email
      country: $country
      lastName: $lastName
    ) {
      status
      message
    }
  }
`;

export const CREATE_KAABO_PARTNER = gql`
  mutation CreateKaaboPartner(
    $partnerName: String!
    $email: String!
    $country: String!
  ) {
    createKaaboPartner(
      partnerName: $partnerName
      email: $email
      country: $country
    ) {
      status
      message
      data {
        id
        partnerName
        email
        code
        partnerId
        status
        createdAt
      }
    }
  }
`;

export const UPDATE_PARTNER_STATUS = gql`
  mutation UpdatePartnerStatus($partnerId: String!, $isActive: Boolean!) {
    updatePartnerStatus(partnerId: $partnerId, isActive: $isActive) {
      status
      message
    }
  }
`;

export const CREATE_KAABO_COUPON = gql`
  mutation CreateKaaboCoupon($input: CreateCouponInput!) {
    createCoupon(input: $input) {
      status
      message
      data {
        id
        couponCode
        couponAlias
        partnerId
        expiryDate
        discountType
        discountValue
        status
      }
    }
  }
`;

export const UPDATE_KAABO_COUPON = gql`
  mutation UpdateKaaboCoupon($couponId: String!, $input: UpdateCouponInput!) {
    updateCoupon(couponId: $couponId, input: $input) {
      status
      message
      data {
        id
        couponCode
        couponAlias
        partnerId
        expiryDate
        maxUses
        discountType
        discountValue
        status
        modifiedBy
      }
    }
  }
`;

export const DEACTIVATE_KAABO_COUPON = gql`
  mutation DeactivateKaaboCoupon($couponId: String!) {
    deactivateCoupon(couponId: $couponId) {
      status
      message
      data {
        id
        status
        modifiedBy
      }
    }
  }
`;

export const DELETE_KAABO_COUPON = gql`
  mutation DeleteKaaboCoupon($couponId: String!) {
    deleteCoupon(couponId: $couponId) {
      status
      message
    }
  }
`;

export const GENERATE_EQUIFAX_METRO_2_FILE = gql`
  mutation equifaxGenerateMetro2File($rentPaymentId: String!) {
    equifaxGenerateMetro2File(rentPaymentId: $rentPaymentId) {
      status
      message
      url
    }
  }
`;

export const MARK_AS_SUBMITTED_TO_EQUIFAX = gql`
  mutation equifaxUpdateToSubmitted($rentPaymentId: String!) {
    equifaxUpdateToSubmitted(rentPaymentId: $rentPaymentId) {
      status
      message
    }
  }
`;

export const GENERATE_EQUIFAX_METRO_2_FILE_PER_MONTH = gql`
  mutation equifaxGenerateMetro2FileSpecificMonth($monthYear: String!) {
    equifaxGenerateMetro2FileSpecificMonth(monthYear: $monthYear) {
      status
      message
      url
    }
  }
`;

export const MARK_AS_SUBMITTED_TO_EQUIFAX_BY_MONTH = gql`
  mutation equifaxUpdateSubmittedReportByMonth($id: String!) {
    equifaxUpdateSubmittedReportByMonth(id: $id) {
      status
      message
    }
  }
`;
